import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  SocialItemElement,
} from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<SocialItemElement>["defaultData"] = {
  attributes: {
    align: "left",
    color: "#000",
    "border-radius": "3px",
    "font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    "font-size": "13px",
    "line-height": "1",
    padding: "4px",
    "padding-top": "4px",
    "padding-right": "4px",
    "padding-bottom": "4px",
    "padding-left": "4px",
    "text-padding": "4px 4px 4px 0",
    target: "_blank",
    "text-decoration": "none",
    "vertical-align": "middle",
  },
  data: {},
};

export const SocialElement = createBlock<SocialItemElement>({
  get name() {
    return t("Social Item");
  },
  defaultData,
  type: BasicType.SOCIAL_ELEMENT,
  create: (payload) => {
    const defaultData: SocialItemElement = {
      type: BasicType.SOCIAL_ELEMENT,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.SOCIAL_ELEMENT,
  render(params) {
    return <BasicBlock params={params} tag="mj-social-element" />;
  },
});
